import { render } from "./EditBeat.vue?vue&type=template&id=65dd2522"
import script from "./EditBeat.vue?vue&type=script&lang=js"
export * from "./EditBeat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\WEB KIM\\pjp-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__